import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { StakingOverviewState } from "../entities/staking-overview-state.model";

const initialState: StakingOverviewState = {
	init: false,
	hasError: false,
	nonStakedAssetsCount: 0,
	totalEarnedRewards: 0,
	totalStakedAmount: 0,
	overviewItems: [],
	autoStakeAssets: [],
	highestOwnedApr: 0,
	hasHistory: false
};

@Injectable()
export class StakingOverviewStateService extends StateService<StakingOverviewState> {
	constructor() {
		super(initialState);
	}

	public getOverviewState$(): Observable<StakingOverviewState> {
		return this.select((state) => state);
	}

	public updateOverviewState(overviewState: Partial<StakingOverviewState>): void {
		this.setState(overviewState);
	}

	public isStakingOverviewStateLoaded(): boolean {
		return !!this.state;
	}
}
